var React = require('react');

function EncryptedIcon (props) {
    return React.createElement("svg",props,React.createElement("g",{"opacity":"0.6"},React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M9 2H8C6.61929 2 5.5 3.11929 5.5 4.5V6H11.5V4.5C11.5 3.11929 10.3807 2 9 2ZM3.5 4.5V6C2.39543 6 1.5 6.89543 1.5 8V14C1.5 15.1046 2.39543 16 3.5 16H13.5C14.6046 16 15.5 15.1046 15.5 14V8C15.5 6.89543 14.6046 6 13.5 6V4.5C13.5 2.01472 11.4853 0 9 0H8C5.51472 0 3.5 2.01472 3.5 4.5ZM3.5 8H13.5V14H3.5V8ZM8.5 12C9.05229 12 9.5 11.5523 9.5 11C9.5 10.4477 9.05229 10 8.5 10C7.94772 10 7.5 10.4477 7.5 11C7.5 11.5523 7.94772 12 8.5 12Z","fill":"#E8EFFF"})));
}

EncryptedIcon.defaultProps = {"width":"17","height":"16","viewBox":"0 0 17 16","fill":"none"};

module.exports = EncryptedIcon;

EncryptedIcon.default = EncryptedIcon;
